module.exports = __webpack_public_path__ + "media/images/emblems/Lovatens-81e00fa26b3459706da4cd8262dc1eb1.png";